import { GetArticleQuery_query_article_Article_machineTags_ArticleMachineTag } from '../../../__generated__/queries-web';

interface ArticleMachineTagsProps {
  assignmentId: string;
  order?: number;
}

export const getArticleMachineTag = ({
  assignmentId,
  order = 0,
}: ArticleMachineTagsProps): GetArticleQuery_query_article_Article_machineTags_ArticleMachineTag => ({
  order,
  __typename: 'ArticleMachineTag',
  machineTag: {
    tag: `topicassignment:id=${assignmentId}`,
    id: assignmentId,
    __typename: 'MachineTag',
  },
});
